module.exports = __webpack_public_path__ + "4c50fabf52c874feac0518a220158d33.svg";